joint.shapes.qad = {};

joint.dia.Element.define('qad.Action', {}, {

    markup: '<rect/><text></text>',

    defaults: joint.util.deepSupplement({

        type: 'qad.Action',
        action: "Action",
        size: { width: 100, height: 70 },
        attrs: {
            'rect': { fill: '#ff9800', stroke: 'none', width: 100, height: 70, rx: 3, ry: 3 },
            'text': { 'font-size': 14, lineHeight: 20, 'ref-x': .5, 'ref-y': .5, ref: 'rect', 'y-alignment': 'middle', 'x-alignment': 'middle', 'font-family': 'Arial, helvetica, sans-serif' }
        },
        description: null,
        assignType: null,
        surveyId: null,
        protocolId: null,
        actionType: null

    }, joint.shapes.basic.Generic.prototype.defaults),

    initialize: function () {

        joint.shapes.basic.Generic.prototype.initialize.apply(this, arguments);

        this.colors = ['rgba(255, 153, 0, 0.85)', 'rgba(232, 86, 86, 0.85)'];

        this.on('change:actionType', function () {
            this.createActionIcons();
        }, this);

        this.createActionIcons();
    },

    createActionIcons: function () {
        var element = this;
        var text = '';
        var listFavicons = [];

        if (element.attributes.actionType === null)
            text = element.attributes.action;

        if (element.attributes.actionType === 0)
            listFavicons.push(jQuery("<div class='icon-in icon-alerta'></div>"));

        if (element.attributes.actionType === 1)
            listFavicons.push(jQuery("<div class='icon-in icon-survey'></div>"));

        if (element.attributes.actionType === 2)
            listFavicons.push(jQuery("<div class='icon-in icon-callback'></div>"));

        if (element.attributes.actionType === 3)
            listFavicons.push(jQuery("<div class='icon-in icon-calendar'></div>"));

        if (element.attributes.actionType === 4)
            listFavicons.push(jQuery("<div class='icon-in icon-more'></div>"));

        if (element.attributes.actionType === 5)
            listFavicons.push(jQuery("<div class='icon-in icon-messaging'></div>"));

        listFavicons.map(function (icon) {
            // on ajoute l'�l�ment cr�� � la page pour que le style soit appliqu�
            icon.appendTo('body');

            // on r�cup�re le caract�re correspondant � l'icone via la propri�t� 'content' sur le :before
            var iconCaracter = window.getComputedStyle(icon[0], ':before').content;

            // on supprime l'objet temporaire
            icon.remove();

            text += iconCaracter.replace(/'|"/g, '');
        });

        this.attr('text/text', text);
        if (element.attributes.actionType != null) {
            this.attr('text/font-size', 25);
            this.attr('text/class', 'icon-in');
        }
    }

    //return {
    //    markup: '<g class="rotatable"><g class="scalable"><rect/></g><text/></g>',
    //    defaults: joint.util.deepSupplement({
    //        type: type,
    //        size: { width: 100, height: 70 },
    //        attrs: {
    //            'rect': { fill: fillColor, stroke: 'none', width: 100, height: 70, rx: 3, ry: 3 },
    //            'text': { 'font-size': 14, lineHeight: 20, 'ref-x': .5, 'ref-y': .5, ref: 'rect', 'y-alignment': 'middle', 'x-alignment': 'middle', 'font-family': 'Arial, helvetica, sans-serif' }
    //        },
    //        title: ''
    //    }, joint.shapes.basic.Generic.prototype.defaults),

    //    initialize: function () {

    //        joint.shapes.basic.Generic.prototype.initialize.apply(this, arguments);

    //        this.attr('text/text', this.get('title'));

    //        this.on('change:thetext', function () {

    //            this.attr('text/text', this.get('title'));

    //        }, this);
    //    }
    //};
});

joint.util.measureText = function (text, attrs) {

    var fontSize = parseInt(attrs.fontSize, 10) || 10;

    var svgDocument = joint.V('svg').node;
    var textElement = joint.V('<text><tspan></tspan></text>').node;
    var textSpan = textElement.firstChild;
    var textNode = document.createTextNode('');

    textSpan.appendChild(textNode);
    svgDocument.appendChild(textElement);
    document.body.appendChild(svgDocument);

    var lines = text.split('\n');
    var width = 0;

    // Find the longest line width.
    _.each(lines, function (line) {

        textNode.data = line;
        var lineWidth = textSpan.getComputedTextLength();

        width = Math.max(width, lineWidth);
    });

    var height = lines.length * (fontSize * 1.2);

    joint.V(svgDocument).remove();

    return { width: width, height: height };
};

joint.shapes.qad.Alertiew = joint.dia.ElementView.extend({

    initialize: function () {
        joint.dia.ElementView.prototype.initialize.apply(this, arguments);
    }
});

joint.dia.Element.define('qad.Question',
    {
        optionHeight: 30,
        options: [],
        questionHeight: 45,
        footerHeight: 30,
        paddingBottom: 30,
        minWidth: 150,
        maxWidth: 200,
        ports: {
            groups: {
                'in': {
                    position: 'top',
                    attrs: {
                        circle: {
                            magnet: 'passive',
                            stroke: 'white',
                            fill: '#42a5f5',
                            r: 14
                        },
                        text: {
                            pointerEvents: 'none',
                            fontSize: 12,
                            fill: 'white'
                        }
                    },
                    label: {
                        position: {
                            name: 'left',
                            args: { x: 5 }
                        }
                    }
                },
                out: {
                    position: 'right',
                    attrs: {
                        'circle': {
                            magnet: true,
                            stroke: 'none',
                            fill: '#31d0c6',
                            r: 14
                        }
                    }
                }
            },
            items: [{
                group: 'in',
                attrs: {
                    text: { text: '' }
                }
            }]
        },
        attrs: {
            '.': {
                magnet: false
            },
            '.body': {
                refWidth: '100%',
                refHeight: '100%',
                rx: 15,
                ry: 15,
                stroke: 'none',
                fill: {
                    type: 'linearGradient',
                    stops: [
                        { offset: '0%', color: '#42a5f5' },
                        { offset: '100%', color: '#31D0C6' }
                    ],
                    // Top-to-bottom gradient.
                    attrs: { x1: '0%', y1: '0%', x2: '0%', y2: '100%' }
                }
            },
            '.options': {
                refX: 0
            },

            // Text styling.
            text: {
                fontFamily: 'Arial'
            },
            '.option-text': {
                fontSize: 11,
                'font-style': 'italic',
                fill: '#4b4a67',
                refX: 10,
                yAlignment: 'middle'
            },
            '.question-text': {
                fontFamily: 'Arial',
                fill: 'white',
                refX: '50%',
                refY: 15,
                fontSize: 15,
                textAnchor: 'middle'
            },
            '.question-text:hover': {
                fill: 'black'
            },
            '.output-text': {
                ref: 'rect',
                fill: 'white',
                stroke: 'black',
                fontSize: 15,
                textAnchor: 'middle'
            },

            // Options styling.
            '.option-rect': {
                rx: 3,
                ry: 3,
                stroke: 'white',
                strokeWidth: 1,
                strokeOpacity: .4,
                fillOpacity: .3,
                fill: 'white',
                refWidth: '100%'
            },

            '.myfooter': {
                fontFamily: 'Arial',
                fill: 'white',
                strokeWidth: .1,
                fontSize: '1.5em',
                textAnchor: 'middle',
                refWidth: '100%',
                refX: '50%',
                'letter-spacing': '10px'
            }
        }
    }, {
    markup: '<rect class="body"/><text class="question-text"/><g class="options"></g><g class="footer-icon"><text class="myfooter icon-in"></text></g>',
    optionMarkup: '<g class="option"><rect class="option-rect"/><text class="option-text"/></g>',

    initialize: function () {
        joint.dia.Element.prototype.initialize.apply(this, arguments);
        this.on('change:options', this.onChangeOptions, this);
        this.on('change:question', function () {
            this.attr('.question-text/text', this.getQuestionShown() || '');
            this.autoresize();
        }, this);

        this.on('change:isTracked', function () {
            this.createFooterIcons();
        }, this);

        this.on('change:isImportant', function () {
            this.createFooterIcons();
        }, this);

        this.on('change:outputId', function () {
            this.createFooterIcons();
        }, this);

        this.on('change:questionHeight', function () {
            this.attr('.options/refY', this.get('questionHeight'), { silent: true });
            this.autoresize();
        }, this);

        this.on('change:optionHeight', this.autoresize, this);

        this.attr('.options/refY', this.get('questionHeight'), { silent: true });
        this.attr('.question-text/text', this.getQuestionShown(), { silent: true });

        this.onChangeOptions();
        this.createFooterIcons();
    },
    onChangeOptions: function () {
        var element = this;
        var otpelem = null;
        var options = this.get('options').sort(function (a, b) { return a.order - b.order; });
        var optionHeight = this.get('optionHeight');

        // First clean up the previously set attrs for the old options object.
        // We mark every new attribute object with the `dynamic` flag set to `true`.
        // This is how we recognize previously set attributes.
        var attrs = this.get('attrs');
        _.each(attrs, function (attrs, selector) {

            if (attrs.dynamic) {
                // Remove silently because we're going to update `attrs`
                // later in this method anyway.
                element.removeAttr(selector, { silent: true });
            }
        }, this);


        // Collect new attrs for the new options.
        var offsetY = 0;
        var attrsUpdate = {};
        var questionHeight = this.get('questionHeight');

        _.each(options, function (option) {
            option.value = options.indexOf(option);
            //if (!option.order)
            option.order = options.indexOf(option);

            var selector = '.option-' + option.id;

            attrsUpdate[selector] = { transform: 'translate(0, ' + offsetY + ')', dynamic: true };
            attrsUpdate[selector + ' .option-rect'] = { height: optionHeight, dynamic: true };

            if (typeof option.text == 'number')
                option.text = option.text.toString();

            var answerText = option.text !== null ? option.text.substring(0, 30) + (option.text.length > 30 ? '...' : '') : '';

            if (element.attributes.typequestion === 5) {
                attrsUpdate[selector + ' .option-text'] = addOptElem(element.attributes.typequestion, answerText, optionHeight);
            }
            else if (element.attributes.typequestion === 13) {
                attrsUpdate[selector + ' .option-text'] = addOptElem(element.attributes.typequestion, answerText, optionHeight);
            }
            else
                attrsUpdate[selector + ' .option-text'] = {
                    text: answerText, dynamic: true, refY: optionHeight / 2
                };

            offsetY += optionHeight;

            var portY = offsetY - optionHeight / 2 + questionHeight;
            if (!element.getPort(option.id)) {
                element.addPort({ group: 'out', id: option.id, args: { y: portY } });
            } else {
                element.portProp(option.id, 'args/y', portY);
            }

        }, element);

        var ports = element.get('ports') ? element.get('ports').items.filter(function (p) {
            return p.group === 'out'
        }) : [];

        _.each(ports, function (port) {
            var opt = options.filter(function (o) { return o.id === port.id; });
            if (!opt.length) {
                element.removePort(port.id);
            }
        }, element);

        element.attr(attrsUpdate);
        element.autoresize();

        var posYIcons = (options.length * 30) + questionHeight + 8;
        this.attr('.myfooter').transform = 'translate(0,' + posYIcons + ')';
    },

    autoresize: function () {

        var options = this.get('options') || [];
        //var gap = this.get('paddingBottom') || 20;
        //var height = options.length * this.get('optionHeight') + this.get('questionHeight') + gap;
        var height = options.length * this.get('optionHeight') + this.get('questionHeight') + this.get('footerHeight');
        var width = joint.util.measureText(this.getQuestionShown(), {
            fontSize: this.attr('.question-text/fontSize')
        }).width;
        this.resize(Math.max(this.get('minWidth'), this.get('maxWidth')), height);
    },

    getQuestionShown: function () {
        return this.get('question').substring(0, 20) + (this.get('question').length > 20 ? '...' : '');
    },

    setOptions: function (optionsArray) {
        // clear all options
        var element = this;
        var options = JSON.parse(JSON.stringify(this.get('options')));
        angular.forEach(options, function (opt) {
            element.removePort(opt.id);
        });

        options = [];
        angular.forEach(optionsArray, function (x) {
            options.push({
                id: _.uniqueId('option-'),
                text: x,
                value: optionsArray.indexOf(x)
            });
        });
        this.set('options', options);
    },

    addOption: function (option) {
        var options = JSON.parse(JSON.stringify(this.get('options')));
        options.push(option);
        // TODO IMPORTANT : FIND A FIX because this bypass svg error
        /*try { this.set('options', options); }
        catch (e) { this.set('options', options); }*/
        this.set('options', options);
    },

    newOption: function () {
        this.addOption({
            id: _.uniqueId('option-'),
            text: 'Option ' + (this.get('options').length + 1),
            order: this.get('options').length
        });
    },
    removeOption: function (id) {
        var options = JSON.parse(JSON.stringify(this.get('options')));
        this.removePort(id);

        options.map(function (opt, index) {
            opt.order = index;
        });
        this.set('options', _.without(options, _.findWhere(options, { id: id })));
    },

    changeOption: function (id, option) {
        if (!option.id) {
            option.id = id;
        }

        var options = JSON.parse(JSON.stringify(this.get('options')));
        options[_.findIndex(options, { id: id })] = option;
        this.set('options', options);
    },

    // target tracker fav
    createFooterIcons: function () {
        var element = this;
        var text = '';
        var listFavicons = [];

        if (element.attributes.isTracked)
            listFavicons.push(jQuery("<div class='icon-in icon-tracker'></div>"));

        if (element.attributes.isImportant)
            listFavicons.push(jQuery("<div class='icon-in icon-fav'></div>"));

        if (element.attributes.outputId)
            listFavicons.push(jQuery("<div class='icon-in icon-target'></div>"));

        listFavicons.map(function (icon) {
            // on ajoute l'�l�ment cr�� � la page pour que le style soit appliqu�
            icon.appendTo('body');

            // on r�cup�re le caract�re correspondant � l'icone via la propri�t� 'content' sur le :before
            var iconCaracter = window.getComputedStyle(icon[0], ':before').content;

            // on supprime l'objet temporaire
            icon.remove();

            text += iconCaracter.replace(/'|"/g, '');
        });

        this.attr('.myfooter/text', text);
    }
});
joint.shapes.qad.QuestionView = joint.dia.ElementView.extend({

    initialize: function () {

        joint.dia.ElementView.prototype.initialize.apply(this, arguments);
        this.listenTo(this.model, 'change:options', this.renderOptions, this);
    },

    renderMarkup: function () {

        joint.dia.ElementView.prototype.renderMarkup.apply(this, arguments);

        // A holder for all the options.
        this.$options = this.$('.options');
        // Create an SVG element representing one option. This element will
        // be cloned in order to create more options.
        this.elOption = joint.V(this.model.optionMarkup);

        this.renderOptions();
    },

    renderOptions: function () {

        var element = this;

        this.$options.empty();

        _.each(this.model.get('options'), function (option, index) {

            var className = 'option-' + option.id;
            var elOption = element.elOption.clone().addClass(className);
            elOption.attr('option-id', option.id);
            element.$options.append(elOption.node);

        }, this);

        // Apply `attrs` to the newly created SVG elements.
        this.update();
    },
    createOption: function (text) {
        var element = this;
        this.model.addOption({
            id: _.uniqueId('option-'),
            text: text,
            order: element.model.get('options').length
        });
    },
    newOption: function () {
        this.createOption('Option ' + (this.model.get('options').length + 1));
    },
    onRemoveOption: function (evt) {
        this.model.removeOption(joint.V(evt.target.parentNode).attr('id'));
    }
});

//joint.dia.Element.define('qad.Input', {}, simpleElementFactory('qad.Input', '#6d4c41'));

joint.dia.Element.define('qad.Popup', {}, simpleElementFactory('qad.Popup', '#6d4c41'));

joint.dia.Element.define('qad.Tip', {}, simpleElementFactory('qad.Tip', '#7f42bc'));

joint.shapes.qad.ActionView = joint.dia.ElementView.extend({
    initialize: function () {
        joint.dia.ElementView.prototype.initialize.apply(this, arguments);
    }
});

function simpleElementFactory(type, fillColor) {
    return {
        markup: '<g class="rotatable"><g class="scalable"><rect/></g><text/></g>',
        defaults: joint.util.defaultsDeep({
            type: type,
            size: { width: 100, height: 70 },
            attrs: {
                'rect': { fill: fillColor, stroke: 'none', width: 100, height: 70, rx: 3, ry: 3 },
                'text': { 'font-size': 14, lineHeight: 20, 'ref-x': .5, 'ref-y': .5, ref: 'rect', 'y-alignment': 'middle', 'x-alignment': 'middle', 'font-family': 'Arial, helvetica, sans-serif' }
            },
            title: ''
        }, joint.shapes.basic.Generic.prototype.defaults),

        initialize: function () {

            joint.shapes.basic.Generic.prototype.initialize.apply(this, arguments);

            this.attr('text/text', this.get('title'));

            this.on('change:thetext', function () {

                this.attr('text/text', this.get('title'));

            }, this);
        }
    };
}

joint.dia.LightLinkView = joint.dia.CellView.extend({

    node: joint.V('<path class="connection" fill="none" />'),

    init: function () {
        this.vel.attr({
            'class': 'link',
            'model-id': this.model.id
        });
    },

    render: function () {

        var model = this.model;
        this._sourceModel = model.getSourceElement();
        this._targetModel = model.getTargetElement();

        this._sourceModel.on('change:position', this.update, this);
        this._targetModel.on('change:position', this.update, this);

        this.listenTo(model, 'change:vertices change:color change:thickness', this.update);

        var node = this._pathNode = this.node.clone();
        joint.V(this.el).append(node);

        this.update();
    },

    update: function () {

        var sourcePosition = this._sourceModel.get('position');
        var targetPosition = this._targetModel.get('position');
        var node = this._pathNode;
        var model = this.model;

        if (sourcePosition && targetPosition) {

            var sourceSize = this._sourceModel.get('size');
            var targetSize = this._targetModel.get('size');

            sourcePosition = {
                x: sourcePosition.x + sourceSize.width / 2,
                y: sourcePosition.y + sourceSize.height / 2
            };
            targetPosition = {
                x: targetPosition.x + targetSize.width / 2,
                y: targetPosition.y + targetSize.height / 2
            };

            var connector = (model.get('smooth')) ? 'smooth' : 'normal';

            node.attr('d', joint.connectors[connector](
                sourcePosition,
                targetPosition,
                model.get('vertices') || []
            ));
        }

        node.attr({
            'stroke': model.get('color') || 'black',
            'stroke-width': model.get('thickness') || 1
        });
    }
});

function entityForSymbolInContainer(character) {
    var code = character.replace(/"/g, '').charCodeAt(0);
    var codeHex = code.toString(16).toUpperCase();
    while (codeHex.length < 4) {
        codeHex = "0" + codeHex;
    }
    return "\\" + codeHex + ";";
}

function addOptElem(type, answerText, height) {
    var iconClass = '';
    if (type === 5) {
        iconClass = 'icon-smiley';
    }
    else if (type === 13) {
        iconClass = 'icon-success';
    }
    // question de type smiley, on cr�� un �l�ment avec la class contenant l'icone � afficher
    otpelem = jQuery("<div class='" + 'icon-in ' + iconClass + answerText + "'></div>");

    // on ajoute l'�l�ment cr�� � la page pour que le style soit appliqu�
    otpelem.appendTo('body');

    // on r�cup�re le caract�re correspondant � l'icone via la propri�t� 'content' sur le :before
    var iconCaracter = window.getComputedStyle(otpelem[0], ':before').content;

    // on supprime l'objet temporaire
    otpelem.remove();

    return {
        text: iconCaracter.replace(/'|"/g, ''), dynamic: true, refY: height / 2, 'font-size': '1.5em', class: 'icon-in icon-smiley' + answerText
    };
}